import React from 'react';
import { Icon, IconNames } from '../Icon/Icon';
import cn from 'classnames';

interface FeedbackProps {
  title: string;
  description: string
  icon?: IconNames;
}

export const Feedback: React.FC<FeedbackProps> = ({ title, description, icon }) => {
  return (
    <div className={cn`
      fixed inset-0 bg-red-600 p-4 md:p-8 flex z-50 bg-twilight-light text-twilight-dark 
      justify-center items-center text-center
    `}
    >
      <div className="max-w-screen-sm flex items-center flex-col space-y-6">
        {icon && <Icon icon={icon} width={96} />}
        <div className="space-y-4">
          <h4>{title}</h4>
          <p className="mb-0">{description}</p>
        </div>
      </div>
    </div>
  );
};
